/**
 * Footer — zapis do newslettera.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var cfg = window.customwearNewsletter || null;
    var form = document.querySelector('[data-cw-newsletter-form]');
    if (!cfg || !form) {
      return;
    }

    var emailInput = form.querySelector('[data-cw-newsletter-email]');
    var consent = form.querySelector('[data-cw-newsletter-consent]');
    var btn = form.querySelector('[data-cw-newsletter-submit]');
    var status = form.querySelector('[data-cw-newsletter-status]');
    var i18n = cfg.i18n || {};

    function setStatus(text, ok) {
      if (!status) {
        return;
      }
      status.hidden = !text;
      status.textContent = text || '';
      status.classList.toggle('cw-footer__newsletter-status--ok', !!ok);
      status.classList.toggle('cw-footer__newsletter-status--err', !!text && !ok);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email || email.indexOf('@') < 1) {
        setStatus(i18n.invalid || 'Podaj poprawny adres e-mail.', false);
        if (emailInput) {
          emailInput.focus();
        }
        return;
      }
      if (consent && !consent.checked) {
        setStatus(i18n.consent || 'Zaznacz zgodę na newsletter.', false);
        consent.focus();
        return;
      }

      if (btn) {
        btn.disabled = true;
        btn.textContent = i18n.sending || 'Zapisuję…';
      }
      setStatus('', false);

      var body = new FormData();
      body.append('action', cfg.action || 'cw_newsletter_subscribe');
      body.append('nonce', cfg.nonce || '');
      body.append('email', email);
      body.append('consent', '1');
      var hp = form.querySelector('[data-cw-newsletter-hp]');
      if (hp) {
        body.append('website', hp.value || '');
      }

      fetch(cfg.ajaxUrl || '/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        body: body,
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          var msg =
            (data.data && data.data.message) ||
            data.message ||
            (result.ok && data.success
              ? 'Dziękujemy!'
              : 'Nie udało się zapisać. Spróbuj ponownie.');
          if (result.ok && data.success) {
            setStatus(msg, true);
            if (emailInput) {
              emailInput.value = '';
            }
            if (consent) {
              consent.checked = false;
            }
          } else {
            setStatus(msg, false);
          }
        })
        .catch(function () {
          setStatus('Nie udało się zapisać. Spróbuj ponownie.', false);
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = i18n.ok || 'OK';
          }
        });
    });
  });
})();
